// src/redux/AllPropertiesSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import i18n from "../../i18n/i18n";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const fetchAgencyMarketing = createAsyncThunk(
  "agency_marketing/fetchAgencyMarketing",
  async ({ page = 1, type = "", filter = "" }, { rejectWithValue }) => {
    try {
      let url = `${BASE_URL}/api/users?page=${page}`;
      if (type) url += `&type=${type}`;
      if (filter) url += `&${type}_type=${filter}`;

      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Lang: i18n.language,
        },
      });

      return {
        data: response.data.data,
        pagination: response.data.pagination,
      };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Failed to load");
    }
  }
);

// Initial state
const initialState = {
  agency_marketing: [],
  isLoading: false,
  pagination: null,
  success: null,
  error: null,
  filters: {
    type: "",
    filter: "",
  },
};

// Slice
const AgencyMarketingSlice = createSlice({
  name: "agency_marketing",
  initialState,
  reducers: {
    clearState: (state) => {
      state.isLoading = false;
      state.success = null;
      state.error = null;
    },
    setFilters: (state, action) => {
      const { type, filter } = action.payload;
      state.filters.type = type;
      state.filters.filter = filter;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAgencyMarketing.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.success = null;
      })
      .addCase(fetchAgencyMarketing.fulfilled, (state, action) => {
        state.isLoading = false;
        state.agency_marketing = action.payload.data;
        state.pagination = action.payload.pagination;
        state.success = true;
      })
      .addCase(fetchAgencyMarketing.rejected, (state, action) => {
        state.isLoading = false;
        state.success = false;
        state.error =
          action.payload || action.error?.message || "Something went wrong";
      });
  },
});

// Exports
export const { clearState, setFilters } = AgencyMarketingSlice.actions;
export default AgencyMarketingSlice.reducer;
